/** Injectable clock so tests can freeze / advance time. */

export type Clock = () => number;

let clockImpl: Clock = () => Date.now();

/** Current time in ms (epoch). */
export function now(): number {
  return clockImpl();
}

/** Replace the clock (tests). Returns restore function. */
export function setClock(next: Clock): () => void {
  const prev = clockImpl;
  clockImpl = next;
  return () => {
    clockImpl = prev;
  };
}

/** Reset to Date.now. */
export function resetClock(): void {
  clockImpl = () => Date.now();
}
